// MWC Watch Detail - Photo module
// Handles photo upload, thumbnail selection, set-main-photo and delete-photo actions.
// Uses MWCWatchDetailReload to re-render the watch detail after changes.

(function () {
  window.MWCWatchDetailPhotos = {
    selectThumbnail: selectThumbnail,
    setMainPhoto: setMainPhoto,
    deletePhoto: deletePhoto,
    uploadPhotos: uploadPhotos
  };

  function selectThumbnail(thumbBtn) {
    const root = document.getElementById("mwc-watch-detail");
    const mainImage = root ? root.querySelector("[data-mwc-main-photo]") : null;
    const nextUrl = thumbBtn ? thumbBtn.getAttribute("data-mwc-thumb") : "";

    if (!root || !thumbBtn || !mainImage || !nextUrl) {
      return;
    }

    mainImage.src = nextUrl;

    const thumbButtons = root.querySelectorAll("[data-mwc-thumb]");

    thumbButtons.forEach(function (button) {
      button.style.border = "1px solid #ddd";
      button.setAttribute("aria-pressed", "false");
    });

    thumbBtn.style.border = "2px solid #111";
    thumbBtn.setAttribute("aria-pressed", "true");

    const allSetMainBtns = root.querySelectorAll("[data-mwc-set-main-photo-disabled]");

    allSetMainBtns.forEach(function (btn) {
      btn.classList.add("hidden");
    });

    const selectedIndex = thumbBtn.getAttribute("data-mwc-thumb-index");

    if (selectedIndex !== "0") {
      const wrapper = thumbBtn.closest("[data-mwc-thumb-wrapper]");
      const setMainBtn = wrapper ? wrapper.querySelector("[data-mwc-set-main-photo-disabled]") : null;

      if (setMainBtn) {
        setMainBtn.classList.remove("hidden");
      }
    }

    const allDeleteBtns = root.querySelectorAll("[data-mwc-delete-photo]");

    allDeleteBtns.forEach(function (btn) {
      btn.classList.add("hidden");
    });

    if (selectedIndex !== "0") {
      const wrapper = thumbBtn.closest("[data-mwc-thumb-wrapper]");
      const deleteBtn = wrapper ? wrapper.querySelector("[data-mwc-delete-photo]") : null;

      if (deleteBtn) {
        deleteBtn.classList.remove("hidden");
      }
    }
  }

  async function setMainPhoto(photoUrl, watchId) {
    if (!photoUrl || !watchId) return;

    try {
      const data = await MWC.getMyWatches();

      const watch = data.find(function (w) {
        return w.id === watchId;
      });

      if (!watch) {
        throw new Error("Watch not found");
      }

      const photos = window.MWCWatchDetailUtils.parsePhotos(watch.photos);

      const updatedPhotos = [photoUrl].concat(
        photos.filter(function (url) {
          return url !== photoUrl;
        })
      ).slice(0, 5);

      await MWC.updateWatch({
        id: watchId,
        photos: updatedPhotos
      });

      window.mwcWatchDetailLoaded = false;

      if (typeof window.MWCWatchDetailReload === "function") {
        window.MWCWatchDetailReload();
      }
    } catch (error) {
      console.error("Failed to set main photo", error);
      alert("Could not set main photo.");
    }
  }

  async function deletePhoto(photoUrl, watchId) {
    if (!photoUrl || !watchId) return;

    const confirmed = window.confirm("Delete this photo from this watch?");
    if (!confirmed) return;

    try {
      const data = await MWC.getMyWatches();

      const watch = data.find(function (w) {
        return w.id === watchId;
      });

      if (!watch) {
        throw new Error("Watch not found");
      }

      const photos = window.MWCWatchDetailUtils.parsePhotos(watch.photos);

      const updatedPhotos = photos.filter(function (url) {
        return url !== photoUrl;
      });

      await MWC.updateWatch({
        id: watchId,
        photos: updatedPhotos
      });

      window.mwcWatchDetailLoaded = false;

      if (typeof window.MWCWatchDetailReload === "function") {
        window.MWCWatchDetailReload();
      }
    } catch (error) {
      console.error("Failed to delete photo", error);
      alert("Could not delete photo.");
    }
  }

  async function uploadPhotos(uploadInput, watchId) {
    if (!uploadInput || !uploadInput.files || !uploadInput.files.length || !watchId) {
      return;
    }

    try {
      const data = await MWC.getMyWatches();

      const watch = data.find(function (w) {
        return w.id === watchId;
      });

      if (!watch) {
        throw new Error("Watch not found");
      }

      const photos = window.MWCWatchDetailUtils.parsePhotos(watch.photos);

      if (photos.length >= 5) {
        alert("You can upload a maximum of 5 photos.");
        uploadInput.value = "";
        return;
      }

      const remainingSlots = 5 - photos.length;
      const files = Array.from(uploadInput.files).slice(0, remainingSlots);

      if (!files.length) {
        uploadInput.value = "";
        return;
      }

      const uploadResult = await MWC.uploadWatchPhotos({
        id: watchId,
        files: [files[0]]
      });

      if (!uploadResult || !uploadResult.url) {
        throw new Error("Upload succeeded but no photo URL returned");
      }

      const updatedPhotos = photos.concat(uploadResult.url).slice(0, 5);

      await MWC.updateWatch({
        id: watchId,
        photos: updatedPhotos
      });

      uploadInput.value = "";
      window.mwcWatchDetailLoaded = false;

      if (typeof window.MWCWatchDetailReload === "function") {
        window.MWCWatchDetailReload();
      }
    } catch (error) {
      console.error("Upload failed", error);
      alert(error.message || "Upload failed");
    }
  }


})();